import {
  InterventionScopeNameEnum,
  TaskScopeNameEnum,
  UserScopeNameEnum,
  useDepartmentsSearchListLazyQuery,
  useInterventionsSearchListLazyQuery,
  useTasksSearchListLazyQuery,
  useTeamsSearchListLazyQuery,
  useUsersSearchListLazyQuery,
} from 'graphql-common';
import { getUsersLoadOptions as getUsersLoadOptionsFn } from 'utils/fetch/searchLists/usersSearchList';
import { getTeamsLoadOptions as getTeamsLoadOptionsFn } from 'utils/fetch/searchLists/teamsSearchList';
import { getDepartmentsLoadOptions as getDepartmentsLoadOptionsFn } from 'utils/fetch/searchLists/departmentsSearchList';
import { getInterventionsLoadOptions as getInterventionsLoadOptionsFn } from 'utils/fetch/searchLists/interventionsSearchList';
import { getTasksLoadOptions as getTasksLoadOptionsFn } from 'utils/fetch/searchLists/tasksSearchList';

export default function useSearchListQueries() {
  // Users (members + responsible manager) — only active users are valid
  // members/managers on the BE, so exclude deactivated users from the picker.
  const [fetchUsersSearchListLazyQuery] = useUsersSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getUsersLoadOptions = () =>
    getUsersLoadOptionsFn(fetchUsersSearchListLazyQuery, {
      name: UserScopeNameEnum.Active,
    });

  // Access groups (Teams)
  const [fetchTeamsSearchListLazyQuery] = useTeamsSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getTeamsLoadOptions = () =>
    getTeamsLoadOptionsFn(fetchTeamsSearchListLazyQuery);

  // Parent department
  const [fetchDepartmentsSearchListLazyQuery] =
    useDepartmentsSearchListLazyQuery({
      fetchPolicy: 'cache-and-network',
    });
  const getDepartmentsLoadOptions = () =>
    getDepartmentsLoadOptionsFn(fetchDepartmentsSearchListLazyQuery);

  // Linked interventions — only open interventions can be linked to a
  // department on the BE, so exclude closed ones from the picker.
  const [fetchInterventionsSearchListLazyQuery] =
    useInterventionsSearchListLazyQuery({
      fetchPolicy: 'cache-and-network',
    });
  const getInterventionsLoadOptions = () =>
    getInterventionsLoadOptionsFn(
      fetchInterventionsSearchListLazyQuery,
      InterventionScopeNameEnum.Opened,
    );

  // Linked tasks (label resolution for the tasks field; selection itself
  // happens through TasksTableMultiselect)
  const [fetchTasksSearchListLazyQuery] = useTasksSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getTasksLoadOptions = () =>
    getTasksLoadOptionsFn({
      fetchLazyQuery: fetchTasksSearchListLazyQuery,
      scope: { name: TaskScopeNameEnum.Active },
      selectedSiteIds: [],
    });

  return {
    getUsersLoadOptions,
    getTeamsLoadOptions,
    getDepartmentsLoadOptions,
    getInterventionsLoadOptions,
    getTasksLoadOptions,
  };
}
